import {SyncDevice} from "./SyncDevice";
import appDb from "../../infrastructure/persistence/indexed-db";

const isSyncDeviceRegistered = async (deviceUUID: SyncDevice['uuid']) => {
    const syncStatuses = await appDb.syncable.list();
    return syncStatuses.includes(deviceUUID);
}

export default isSyncDeviceRegistered;